import { render, staticRenderFns } from "./ToolboxTalkForm.vue?vue&type=template&id=587e7010&"
import script from "./ToolboxTalkForm.vue?vue&type=script&lang=js&"
export * from "./ToolboxTalkForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports